/* ================================================================
   8TH SIN — PRODUCT PAGE JS v4
   Fixes: variant sync updates ALL buttons (mobile + desktop)
   Carousel · tabs · variant selection · toast
   ================================================================ */
(function () {
  'use strict';

  var variants = window.__8thSinVariants || [];
  var selectedOptions = {};

  /* ── MOBILE CAROUSEL ── */
  var track = document.getElementById('pmTrack');
  if (track) {
    var slides = track.querySelectorAll('.pm-slide');
    var total  = slides.length;
    var cur = 0, startX = null, isDrag = false, dragDx = 0;

    function goTo(i) {
      cur = ((i % total) + total) % total;
      track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      var counter = document.getElementById('pmCarouselCurrent');
      if (counter) counter.textContent = cur + 1;
    }

    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1);
      startX = null;
    });
    track.addEventListener('mousedown', function(e) {
      startX = e.clientX; isDrag = true;
      track.classList.add('dragging');
    });
    window.addEventListener('mousemove', function(e) {
      if (isDrag) dragDx = e.clientX - startX;
    });
    window.addEventListener('mouseup', function() {
      if (!isDrag) return;
      isDrag = false; track.classList.remove('dragging');
      if (Math.abs(dragDx) > 50) goTo(dragDx < 0 ? cur + 1 : cur - 1);
      else goTo(cur);
      startX = null; dragDx = 0;
    });
  }

  /* ── TABS (both mobile and desktop instances) ── */
  document.querySelectorAll('.pm-tabs').forEach(function(tabBlock) {
    tabBlock.querySelectorAll('.pm-tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = btn.dataset.tab;
        tabBlock.querySelectorAll('.pm-tab-btn').forEach(function(b) { b.classList.remove('active'); });
        tabBlock.querySelectorAll('.pm-tab-panel').forEach(function(p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = tabBlock.querySelector('[data-panel="' + tab + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });

  /* ── VARIANT MATCHING ── */
  function findVariant() {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) { return selectedOptions[i] === opt; });
    }) || null;
  }

  /* ── UPDATE ALL BUTTONS + PRICES ── */
  function applyVariant(variant) {
    if (!variant) return;

    /* Update price everywhere */
    var price = formatMoney(variant.price);
    ['pmPriceMobile', 'pmPriceDesk'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = price;
    });

    /* Update ALL ATC buttons by class — this fixes mobile */
    document.querySelectorAll('.pm-btn-atc').forEach(function(btn) {
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
      if (!btn.classList.contains('added')) {
        btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    });

    /* Update ALL Buy Now buttons by class — this fixes mobile */
    document.querySelectorAll('.pm-btn-buy').forEach(function(btn) {
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
    });

    /* Update URL without reload */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* ── OPTION BUTTON CLICKS ── */
  document.querySelectorAll('.pm-option-btns').forEach(function(group) {
    var idx = parseInt(group.dataset.optionIndex, 10);

    /* Seed initial selection */
    var selectedBtn = group.querySelector('.pm-opt-btn.selected');
    if (selectedBtn) selectedOptions[idx] = selectedBtn.dataset.value;

    group.querySelectorAll('.pm-opt-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        /* Deselect all in same option-index across both mobile + desktop */
        document.querySelectorAll('[data-option-index="' + idx + '"] .pm-opt-btn').forEach(function(b) {
          b.classList.remove('selected');
        });
        /* Select matching value in all instances */
        document.querySelectorAll('[data-option-index="' + idx + '"] [data-value="' + btn.dataset.value + '"]').forEach(function(b) {
          b.classList.add('selected');
        });

        selectedOptions[idx] = btn.dataset.value;
        var match = findVariant();
        if (match) applyVariant(match);
        markUnavailable();
      });
    });
  });

  function markUnavailable() {
    document.querySelectorAll('.pm-option-btns').forEach(function(group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      group.querySelectorAll('.pm-opt-btn').forEach(function(btn) {
        var test = Object.assign({}, selectedOptions);
        test[idx] = btn.dataset.value;
        var avail = variants.some(function(v) {
          return v.options.every(function(o, i) { return test[i] === undefined || test[i] === o; }) && v.available;
        });
        btn.classList.toggle('unavailable', !avail);
      });
    });
  }

  markUnavailable();

  /* ── FORMAT MONEY ── */
  function formatMoney(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  /* ── CART COUNT ON LOAD ── */
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(d) {
      document.querySelectorAll('.cart-count, .cv-cart-count').forEach(function(el) {
        el.textContent = d.item_count;
      });
    })
    .catch(function() {});

})();
